
import { defineComponent, onActivated, onBeforeUnmount, onDeactivated, onMounted, nextTick, watch } from 'vue'
import resize from './mixins/resize'
import { init, EChartsOption } from 'echarts'
import moment from 'moment';
import * as echarts from 'echarts'
export default defineComponent({
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'lineChartsCompoents'
    },
    width: {
      type: String,
      default: '100%',
      required: true
    },
    height: {
      type: String,
      default: '260px',
      required: true
    },
    chartData: {
      type: Object,
      default: []
    }
  },
  setup(props) {
    watch(props, (newName, oldName) => {
      initChart()
    });
    const {
      mounted,
      chart,
      beforeDestroy,
      activated,
      deactivated
    } = resize()
    const initChart = () => {
      if( !props.chartData.length ){
        return false
      }
      const barChart = init(document.getElementById(props.id) as HTMLDivElement)
     
      let xData = [];
      let yData = [];
      let otherData: any[] = [];
      let mapData = JSON.parse(JSON.stringify( props.chartData))
      for (let index = 0; index < mapData.length; index++) {
      //   // mapData[index].maxGoalPrice = Number(mapData[index].maxGoalPrice.toFixed(2))
      //   // mapData[index].minGoalPrice = Number(mapData[index].minGoalPrice.toFixed(2))

        xData.push(mapData[index].target) 
        yData.push(mapData[index].percentage)
        otherData.push(mapData[index].stockNumber);
      //   serviesData2.push(Number(mapData[index].maxGoalPrice - mapData[index].minGoalPrice).toFixed(2) )
      //   serviesData3.push(mapData[index].avgGoalPrice)
      }
      barChart.setOption({
        legend:{
          // top: 20,
          left: '15px',
          icon: 'circle',
          // itemWidth: 14,
          // itemHeight: 5,
          // itemGap: 13,
          // data: ['CMCC', 'CTCC', 'CUCC'],
          // right: '4%',
          textStyle: {
            fontSize: 14,
            color: '#666'
          }
        },
        tooltip: {
          trigger: 'axis',
          formatter: (params:any) => {
            params = params[0];
            return `${params.name}<br />新增调研覆盖个股数量：${otherData[params.dataIndex]}家`
          },
          // axisPointer: {
          //   type: 'shadow'
          // },
          // backgroundColor: "rgba(21,84,155,0.67)", // 修改背景颜色
          // borderColor: "transparent", // 修改边框颜色
          // borderRadius: 10,
          // formatter:function(param:any){
          //   // console.log(mapData[param[0].dataIndex].maxGoalPrice)
          //   // 利用循环更改显示的内容
          //   let list = param.length
          //   // let Oparam=param
          //   let txt = '<div style="padding-bottom:10px;color:#fff">' + param[0].name+"</div>"
          //   for (var i=0;i<list;i++){
          //     if(i==list-1){
          //       //最小值
          //       txt += '<div style="color:#fff">' + param[i].seriesName + "：" + mapData[param[0].dataIndex].minGoalPrice.toFixed(2) + '</div>'
          //     }else if(i === 0){
          //       txt += '<div style="padding-bottom:10px;color:#fff">' +  param[i].seriesName + "：" + mapData[param[0].dataIndex].maxGoalPrice.toFixed(2) + '</div>'
          //     }else{
          //       txt += '<div style="padding-bottom:10px;color:#fff">' + param[i].seriesName + "：" + mapData[param[0].dataIndex].avgGoalPrice.toFixed(2) + '</div>'
          //     }
          //   }
          //   return txt
          // }
        },
        grid: {
          left: '20px',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: xData,
            axisTick: {
              show:false,
              alignWithLabel: true
            },
            axisLabel: {
              color:  'rgba(66, 129, 236, 0.5)',
              // interval: 0,
              // formatter: function(value:any) {
              //   return value.split('').join('\n')
              // },
            },
            axisLine: {
              show:true,
              lineStyle: {
                color: '#EEEEEE',
                width:1
              }
            },
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLine: {
              show:false,
              lineStyle: {
                color: '#E8E8E8',
                width:1
              }
            },
            axisLabel: {
              color:  '#2E2E2E',
              formatter: '{value}%'
            },
          }
        ],
        series: [
          {
            name: '新增调研覆盖个股数量（家）',
            data: yData,
            type: 'bar',
            barWidth: '50',
            color: '#3B7FEE',
            label: {
              show: true,
              position: 'top',
              formatter: (params:any) => {
                return `${otherData[params.dataIndex]}家`
              },
            },
          }
        ]
      } as EChartsOption)
      chart.value = barChart

      barChart.on('click', (params:any) => {
        // const beginDate = moment().startOf('year').format('YYYY-MM-DD');
        // const endDate = moment().format('YYYY-MM-DD');
        const beginDate = '2022-01-01';
        const endDate = '2022-12-31';
        const arr = [
          {
            name: '<30亿',
            valFrom: '',
            valTo: 30,
          },
          {
            name: '30-50亿',
            valFrom: 30,
            valTo: 50,
          },
          {
            name: '50-100亿',
            valFrom: 50,
            valTo: 100,
          },
          {
            name: '100-200亿',
            valFrom: 100,
            valTo: 200,
          },
          {
            name: '200-300亿',
            valFrom: 200,
            valTo: 300,
          },
          {
            name: '300-500亿',
            valFrom: 300,
            valTo: 500,
          },
          {
            name: '≥500',
            valFrom: 500,
            valTo: '',
          },
        ]
        const newObj = arr.find((item) => item.name === params.name) as any;
        window.open(`/investment/research/list?isFirstFollow=1&timeLevel=5&beginDate=${beginDate}&endDate=${endDate}&section=${newObj.valFrom},${newObj.valTo}`)
      })
    }

    onMounted(() => {
      mounted()
      nextTick(() => {
        initChart()
      })
    })

    onBeforeUnmount(() => {
      beforeDestroy()
    })

    onActivated(() => {
      activated()
    })

    onDeactivated(() => {
      deactivated()
    })

    return {

    }
  }
})
